import React from "react";
import { ExternalLinkButton } from "components/common";
import { ButtonToolbar } from "components/bootstrap";
const ProductLink = ({ href = "", clusterId = void 0, children = void 0 }) => {
  let hrefWithParam = href;
  if (clusterId) {
    hrefWithParam = `${hrefWithParam}?cluster_id=${clusterId}`;
  }
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(ExternalLinkButton, { target: "_blank", rel: "noopener noreferrer", href: hrefWithParam, bsStyle: "primary" }, children));
};
export default ProductLink;
